import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import usePageMeta from "@/lib/useSeo";
import { CONTACT_PAGE } from "@/constants/testIds";
import { EnvelopeSimple, Phone, MapPin } from "@phosphor-icons/react";

export default function Contact() {
  usePageMeta({
    title: "Contact · Vape Essence",
    description:
      "Questions about flavours, orders, wholesale, or loyalty? Reach the Vape Essence team — we'll respond within 24 hours.",
  });
  const [content, setContent] = useState({});
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data));
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/content/contact", form);
      toast.success("Message sent", { description: "We'll be in touch within 24 hrs." });
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error("Couldn't send. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto max-w-[1400px] px-4 py-14 sm:px-6 sm:py-24 lg:px-10 lg:py-32">
      <div className="font-label text-xs text-[#00FFC2]">/ CONTACT</div>
      <h1 className="mt-3 font-display text-4xl font-black tracking-tighter sm:text-5xl lg:text-7xl">
        Say <span className="text-[#FF5A1F]">hey</span>.
      </h1>
      <p className="mt-4 sm:mt-6 max-w-xl text-sm sm:text-base text-white/60 leading-relaxed">
        Questions about flavours, orders, wholesale, or loyalty? We're on it.
      </p>

      <div className="mt-10 sm:mt-16 grid gap-8 sm:gap-12 lg:grid-cols-5">
        <form onSubmit={submit} className="space-y-5 lg:col-span-3">
          <div className="grid gap-5 md:grid-cols-2">
            <div>
              <label className="mb-2 block font-label text-[10px] text-white/50">Your Name</label>
              <input
                data-testid={CONTACT_PAGE.name}
                required
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                className="w-full border border-white/15 bg-black px-4 py-3 text-sm outline-none focus:border-[#FF5A1F]"
              />
            </div>
            <div>
              <label className="mb-2 block font-label text-[10px] text-white/50">Email</label>
              <input
                data-testid={CONTACT_PAGE.email}
                type="email"
                required
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="w-full border border-white/15 bg-black px-4 py-3 text-sm outline-none focus:border-[#FF5A1F]"
              />
            </div>
          </div>
          <div>
            <label className="mb-2 block font-label text-[10px] text-white/50">Message</label>
            <textarea
              data-testid={CONTACT_PAGE.message}
              required
              rows={6}
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              className="w-full border border-white/15 bg-black px-4 py-3 text-sm outline-none focus:border-[#FF5A1F]"
            />
          </div>
          <button
            data-testid={CONTACT_PAGE.submit}
            disabled={loading}
            className="w-full sm:w-auto bg-[#00FFC2] px-8 py-3 font-label text-xs text-black transition-transform hover:-translate-y-0.5 disabled:opacity-60"
          >
            {loading ? "Sending..." : "Send message"}
          </button>
        </form>

        <div className="lg:col-span-2 space-y-3 sm:space-y-4">
          <div className="border border-white/10 bg-[#0d0d0d] p-5 sm:p-6">
            <EnvelopeSimple size={18} className="text-[#FF5A1F]" />
            <div className="mt-3 font-label text-[10px] text-white/40">EMAIL</div>
            <div className="mt-1 text-sm break-all">{content.contact_email}</div>
          </div>
          <div className="border border-white/10 bg-[#0d0d0d] p-5 sm:p-6">
            <Phone size={18} className="text-[#00FFC2]" />
            <div className="mt-3 font-label text-[10px] text-white/40">PHONE</div>
            <div className="mt-1 text-sm">{content.contact_phone}</div>
          </div>
          <div className="border border-white/10 bg-[#0d0d0d] p-5 sm:p-6">
            <MapPin size={18} className="text-[#FFC900]" />
            <div className="mt-3 font-label text-[10px] text-white/40">ADDRESS</div>
            <div className="mt-1 text-sm">{content.contact_address}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
